import { HIDE_LOADER, SHOW_LOADER } from './common.actions';
const initialState = {
  loadersNumber: 0
};
export default function commonReducer(state = initialState, action) {
  switch (action.type) {
    case SHOW_LOADER:
      return {
        loadersNumber: state.loadersNumber + 1
      };
    case HIDE_LOADER:
      return {
        loadersNumber: Math.max(state.loadersNumber - 1, 0)
      };
    default:
      return state;
  }
}